import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

export const sleep = (time: number): Promise<undefined> =>
	new Promise(resolve => setTimeout(resolve, time));

const routes: CustomRoute = {
	path: '/line-liff',
	components: () => [import('./component')],
	render: ([LineLiff]) => <LineLiff />,
};
export default routes;
